import {
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import type { Doc } from '@/types/sharedTypes';

interface SourceDocumentDialogProps {
  doc: Doc | null | undefined;
  open: boolean;
  handleClose: () => void;
}

function SourceDocumentDialog({
  doc,
  open,
  handleClose,
}: SourceDocumentDialogProps): React.JSX.Element {
  return (
    <Dialog onClose={handleClose} open={open} maxWidth='md'>
      <DialogTitle>
        <Grid container direction='row' alignItems='center'>
          <Grid size={11}>
            <b>
              {doc?.title} - page {doc?.page_number}
            </b>
          </Grid>
          <Grid size={1} sx={{ maxWidth: '25px' }}>
            <IconButton aria-label='close' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box
          padding='10px'
          sx={{
            maxWidth: 800,
          }}
        >
          <Grid container spacing={2} sx={{ width: '100%' }}>
            <Grid size={12}>
              <Typography variant='h6'>Document Snippet</Typography>
            </Grid>
            <Grid size={12}>
              <Divider />
            </Grid>
            <Grid size={12}>
              <Typography variant='body2' sx={{ whiteSpace: 'pre-wrap' }}>
                {doc?.content}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default SourceDocumentDialog;

